import React from 'react'
import { styled } from '../../../assets/theme'

function generateCurve(x1: number, x2: number, height: number) {
  const width = x2-x1;
  const quart = width/4;

  return `M0 ${height} C ${quart} ${height}, ${quart} 0, ${quart*2} 0, ${quart*3} 0, ${quart*3} ${height}, ${quart*4} ${height}`;
}

export const DetailsView: React.FunctionComponent<{}> = () => (
  <GraphWrapper>
    <svg>
      <path
        id='curvedLine'
        d={generateCurve(0, 100, 50)}
        x="0"
        fill="green"
        stroke="black"
        strokeWidth="5px"
      />
    </svg>
  </GraphWrapper>
)

const GraphWrapper = styled.div`
  #curvedLine {
    stroke: ${({ theme }) => theme.core.textColor}
  }
`;